import {
  getV1DealerIdApplicationAppIdHome,
  postV1DealerIdApplicationAppIdHome,
  putV1DealerIdApplicationAppIdHome,
  type DtoCreateHomeReq,
  type DtoUpdateHomeReq,
} from "@porchpass/api-client";
import { assertApiSuccess } from "../utils/assertApiSuccess";
import { EMPTY_REQUEST_BODY } from "./constants";
import { lazyDealerId, requireApplicationId, type DomainIds } from "./types";

export function createHomeDomain(ids: DomainIds) {
  const getDealerId = lazyDealerId(ids);

  return {
    getHome: async (applicationId?: string) => {
      const appId = requireApplicationId(applicationId ?? ids.applicationId);
      const response = await getV1DealerIdApplicationAppIdHome(
        getDealerId(),
        appId,
        EMPTY_REQUEST_BODY,
      );
      return assertApiSuccess(response);
    },

    createHome: async (body: DtoCreateHomeReq, applicationId?: string) => {
      const appId = requireApplicationId(applicationId ?? ids.applicationId);
      const response = await postV1DealerIdApplicationAppIdHome(
        getDealerId(),
        appId,
        body,
      );
      return assertApiSuccess(response);
    },

    updateHome: async (body: DtoUpdateHomeReq, applicationId?: string) => {
      const appId = requireApplicationId(applicationId ?? ids.applicationId);
      const response = await putV1DealerIdApplicationAppIdHome(
        getDealerId(),
        appId,
        body,
      );
      return assertApiSuccess(response);
    },
  };
}
